import { ChildReducerName } from '../constants/other';
import { getCoreState } from './core-state';
export const getErrorState = (state) => getCoreState(state)[ChildReducerName.error];
export const getError = (state, requestId) => getErrorState(state)[requestId];
